export default __webpack_public_path__ + "static/media/ip6X.007d72f5.svg";